<style lang="scss" scoped="scoped">
	p {
		color: #303133;
	}
</style>

<template>
	<div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;justify-content: space-between;">
		<div ref="titleBar" class="titleBar" style="">
			<p style="font-size: 16px;font-weight: 700;">
				{{$t('shengchanjindu')}}
			</p>
		</div>
		<div style="">
			<p style="font-size: 14px;">
				{{$t('zongtishengchanjindu')}}
			</p>
			<p style="font-size: 24px;margin-top:4px">
				{{(progress.planProduct!=0)?((progress.currentProduct/progress.planProduct*100).toFixed(1)+'%'):'-'}}
			</p>
			<div style="height: 18px;background-color: #E4E7ED;width: 100%;position: relative;">
				<div style="height: 18px;background-color: #419FFF;" :style="{width:(progress.currentProduct/progress.planProduct*100)+'%'}">
				</div>
			</div>
		</div>
		
		<div style="display: flex;justify-content: space-between;">
			<div style="width: 49%;">
				<p style="font-size: 14px;">
					{{$t('jihuachanliang')}}
				</p>
				<p style="font-size: 20px;word-wrap:break-word">
					{{progress.planProduct}}
				</p>
			</div>
			<div style="width: 49%;">
				<p style="font-size: 14px;">
					{{$t('leijichanliang')}}
				</p>
				<p style="font-size: 20px;word-wrap:break-word">
					{{progress.currentProduct}}
				</p>
			</div>
		</div>

	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_home_mes_produce',
		components: {

		},

		data() {
			return {
				progress:{},
				timmer: null,
			};
		},
		created() {
			// this.timmer = setInterval(() => {
			// 	 this.getProductProgress()
			// }, 60000)
			 this.getProductProgress()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		watch: {
			'$attrs.orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.getProductProgress()
			},
			
		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {
			async getProductProgress() {
				let response = await this.http.get('/web/equipment/home/getMesProductProgress',{params:{orgId: this.$attrs.orgId}})
				this.progress = response.data

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					// this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight -
					// 	20 - 20
				}, 800)



			},

		}
	};
</script>
